// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import CompareTableComponent from './compareTable';
import withPdbIdsFromStorage from '../withPdbIdsFromStorage';
import { getPricesForPdbIds, getComparedPricesForPdbIds, type PdbPrices } from '../../../store/pdbComparison';
import { selectDefaultConfigForPdbIds } from '../../../store/pdbComparison/actions';
import {
  getAddComparisonText,
  getCompareHeadingText,
  getButtonOrderText,
  getButtonModelInfoText,
  getRowHeadingModelText,
  getRowHeadingTypeText,
  getRowHeadingColorText,
  getRowHeadingDeliveryTimeText,
  getRowHeadingDurationText,
  getRowHeadingKmpackText,
  getRowHeadingClaimFreeText,
  getRowHeadingPriceDifferenceText,
  getRowHeadingPricePerKmText,
  getRowHeadingPriceText,
} from '../../../store/compareSettings/selectors';

type OwnProps = {
  pdbIds: Array<string>,
};

type StateProps = {|
  prices: PdbPrices,
  comparedPrices: Array<number>,
  addComparisonText: string,
  compareHeadingText: string,
  buttonOrderText: string,
  buttonModelInfoText: string,
  rowHeadingModelText: string,
  rowHeadingTypeText: string,
  rowHeadingColorText: string,
  rowHeadingDeliveryTimeText: string,
  rowHeadingDurationText: string,
  rowHeadingKmpackText: string,
  rowHeadingClaimFreeText: string,
  rowHeadingPriceDifferenceText: string,
  rowHeadingPricePerKmText: string,
  rowHeadingPriceText: string,
|};

type DispatchProps = {|
  selectDefaultConfigurations: Function,
|};

type Props = OwnProps & StateProps & DispatchProps;

class CompareTable extends Component<Props> {
  componentDidMount() {
    const { selectDefaultConfigurations } = this.props;
    selectDefaultConfigurations();
  }

  render() {
    return (
      <CompareTableComponent
        {...this.props}
        // addComparisonText={this.props.addComparisonText}
        // compareHeadingText={this.props.compareHeadingText}
        // buttonOrderText={this.props.buttonOrderText}
        // buttonModelInfoText={this.props.buttonModelInfoText}
        // rowHeadingModelText={this.props.rowHeadingModelText}
        // rowHeadingTypeText={this.props.rowHeadingTypeText}
        // rowHeadingColorText={this.props.rowHeadingColorText}
        // rowHeadingDeliveryTimeText={this.props.rowHeadingDeliveryTimeText}
        // rowHeadingDurationText={this.props.rowHeadingDurationText}
        // rowHeadingKmpackText={this.props.rowHeadingKmpackText}
        // rowHeadingClaimFreeText={this.props.rowHeadingClaimFreeText}
        // rowHeadingPriceDifferenceText={this.props.rowHeadingPriceDifferenceText}
        // rowHeadingPricePerKmText={this.props.rowHeadingPricePerKmText}
        // rowHeadingPriceText={this.props.rowHeadingPriceText}
      />
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  prices: getPricesForPdbIds(state),
  comparedPrices: getComparedPricesForPdbIds(state),
  addComparisonText: getAddComparisonText(state),
  compareHeadingText: getCompareHeadingText(state),
  buttonOrderText: getButtonOrderText(state),
  buttonModelInfoText: getButtonModelInfoText(state),
  rowHeadingModelText: getRowHeadingModelText(state),
  rowHeadingTypeText: getRowHeadingTypeText(state),
  rowHeadingColorText: getRowHeadingColorText(state),
  rowHeadingDeliveryTimeText: getRowHeadingDeliveryTimeText(state),
  rowHeadingDurationText: getRowHeadingDurationText(state),
  rowHeadingKmpackText: getRowHeadingKmpackText(state),
  rowHeadingClaimFreeText: getRowHeadingClaimFreeText(state),
  rowHeadingPriceDifferenceText: getRowHeadingPriceDifferenceText(state),
  rowHeadingPricePerKmText: getRowHeadingPricePerKmText(state),
  rowHeadingPriceText: getRowHeadingPriceText(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  selectDefaultConfigurations: () => dispatch(selectDefaultConfigForPdbIds()),
});

export default compose(
  withPdbIdsFromStorage,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(CompareTable);
